import { Wordpress } from "@ecologi/shared";
import { fetchFromAPI } from "../api/fetch-from-api";

export const getProjects = (): Promise<Wordpress.Project[]> =>
  fetchFromAPI("/wordpress/projects");

export const getProjectById = (projectId: number): Promise<Wordpress.Project> =>
  fetchFromAPI(`/wordpress/projects/${projectId}`);
